<template>
  <div>
    <MasterLayout>
      <!-- <div class="fuelbalance_first_row">
        <div
          class="fuelbalance_first_row_right_section tank__bg"
          style="flex: 0 0 96.5%;border-radius: 15px;"
          :style="[
            {
              backgroundImage: `linear-gradient(rgb(12, 4, 31 , 0.7), rgb(12, 4, 31 , 0.7)), url(${backgroundUrl})`,
              backgroundPosition: 'center',
              backgroundRepeat: 'no-repeat',
              backgroundSize: 'cover'
            }
          ]"
        >
          <div class="our__branches__banner" style="width: 100%;height: 150px;">
            <div class="row align-items-center section__row">
              <div class="text-center col-md-7 section___column_1">
                <h3 class="our__branches__banner__title">
                  <img src="@/assets/img/tanks_icon.png" class="mr-3" />Daily branch transactions  ({{transCount}})
                </h3>
              </div>
              <div class="col-md-3 drop_down_input_stations">
                <div class="align-items-center">
                  <div class>
                    <div class="mt-2 mr-2 drop_down_section">
                      <div class="drop_down_div align-items-center">
                        <vue-ctk-date-time-picker
                          v-model="dateRange"
                          :max-date="maxDate"
                          :disabledDates="disabledDates"
                          :onlyDate="true"
                          :autoClose="true"
                          :locale="this.$root.$i18n.locale"
                          :color="$store.getters.getDatePickerColor"
                          format="DDMMYYYY"
                          formatted="DD/MM/YYYY"
                          :label="$t('text.calendar.selectDate')"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div> -->
      <div class="pt-4 pb-3 pl-4 pr-4 dashboard_first_row">
        <div class="py-3 row align-items-center white-bg">
          <div class="col-md-1 remove-right-padding col-center-flex">
            <div class="square-icon-wrapper small sky-bg">
              <img src="@/assets/img/bank-building (2).svg" width="35" />
            </div>
          </div>
          <div class="col-md-8">
            <h4 class="primary-color font-600">
              {{ $t("text.branch.dailyBranchTransaction") }}
            </h4>
            <p class="mt-3 light-grey-text">
              {{ $t("text.branch.viewTransactions") }} <br />
            </p>
          </div>
          <div class="col-md-3">
            <vue-ctk-date-time-picker
              v-model="dateRange"
              :max-date="maxDate"
              :disabledDates="disabledDates"
              :onlyDate="true"
              :autoClose="true"
              :locale="this.$root.$i18n.locale"
              :color="$store.getters.getDatePickerColor"
              format="DDMMYYYY"
              formatted="DD/MM/YYYY"
              :label="$t('text.calendar.selectDate')"
            />
          </div>
        </div>
      </div>
      <section
        v-show="transCount > 0 && !showLoader"
        class="mobile_tanks_filled"
      >
        <div class="mt-3 dashboard__table__section">
          <div class="branch__sales__text_header">
            <div class="row">
              <div class="col-md-8">
                <span>
                  {{ $t("text.branch.branchTransactionOn") }}
                  {{
                    $d(new Date(startDate), "short", this.$root.$i18n.locale)
                  }}
                </span>
              </div>
              <div class="text-right col-md-4"></div>
            </div>
            <ejs-grid
              v-show="!showLoader"
              ref="dataGrid"
              :created="refreshGrid"
              :allowPaging="true"
              :allowSorting="true"
              :pageSettings="pageSettings"
              :toolbar="toolbar"
              :searchSettings="search"
              :allowExcelExport="true"
              :allowPdfExport="true"
              :toolbarClick="toolbarClick"
              :locale="usedLang"
            >
              <e-columns>
                <e-column width="40" field="index" headerText="#"></e-column>
                <e-column
                  field="branch"
                  width="200"
                  :headerText="$t('text.tanksFilledReport.branchName')"
                ></e-column>
                <e-column
                  field="product"
                  width="150"
                  :headerText="$t('text.branch.product')"
                ></e-column>
                <e-column
                  field="transCount"
                  width="150"
                  :headerText="$t('text.branch.transactionCount')"
                ></e-column>
              </e-columns>
            </ejs-grid>
          </div>
        </div>
      </section>
      <section class="mt-5" style="margin: 0 auto; width: 96%">
        <TableLoader :showLoader="showLoader" />
      </section>
    </MasterLayout>
  </div>
</template>

<script>
import Vue from "vue";
import MasterLayout from "@/views/Dealer/MasterLayout.vue";
import backgroundUrl from "@/assets/img/Tankimage.png";
import configObject from "@/config";
import TableLoader from "@/components/tableLoader/index";
import {
  Page,
  Sort,
  Toolbar,
  Search,
  ExcelExport,
  PdfExport,
  Resize,
} from "@syncfusion/ej2-vue-grids";

export default {
  title: "Tanks Filled :: Epump Portal",
  name: "TanksFilled",
  components: {
    MasterLayout,
    TableLoader,
  },
  provide: {
    grid: [Page, Sort, Toolbar, Search, ExcelExport, PdfExport, Resize],
  },
  data() {
    return {
      usedLang: this.$store.getters.getLanguage,
      formatOptions: { type: "date", format: "dd/MM/yyyy" },
      maxDate: this.$moment(new Date()).format("YYYY-MM-DD"),
      dateRange: this.startDate,
      pluginStartDate: this.$moment().format("D-M-YYYY"),
      tanks: [],
      backgroundUrl,
      showLoader: false,
      dealerId: null,
      pageSettings: {
        pageSizes: [10, 20, 50, 100, 200],
        pageCount: 4,
        pageSize: 10,
      },
      toolbar: ["ExcelExport", "PdfExport", "Search"],
      search: { operator: "contains", ignoreCase: true },
      transCount: 0,
      startDate: this.$moment().format("MMMM D, YYYY"),
      today: this.$moment().format("MMMM D, YYYY"),
      monthAgo: this.$moment().subtract(30, "days").format("MMMM D, YYYY"),
      disabledDates: [],
      dealer: null,
    };
  },
  created() {
    this.$eventHub.$on("dealer", (dealer) => {
      this.dealer = dealer;
    });
    if (this.$route.query.dealerId) {
      //   this.getDailyBranchTransactions();
    }
    this.dateRange = this.pluginStartDate;
  },
  mounted() {
    $(".e-input").keyup(function (e) {
      searchFun(e);
    });
    function searchFun(event) {
      var grid = document.getElementsByClassName("e-grid")[0].ej2_instances[0];
      var value = event.target.value;
      grid.search(value);
    }
    // this.getDailyBranchTransactions();
    // this.getDates();
  },
  watch: {
    dealer(dealer) {
      if (dealer !== null) {
        this.getDailyBranchTransactions();
      }
    },
    dateRange: function (newDate) {
      if (newDate) {
        this.startDate = this.$moment(newDate, "DD-MM-YYYY").format(
          "MMMM D, YYYY"
        );

        this.getDailyBranchTransactions();
      }
    },
  },
  methods: {
    //
    toolbarClick(args) {
      switch (args.item.text) {
        case "PDF Export":
          this.$refs.dataGrid.pdfExport();
          break;
        case "Excel Export":
          this.$refs.dataGrid.excelExport();
          break;
      }
    },
    refreshGrid() {
      this.$refs.dataGrid.refresh();
    },

    getDailyBranchTransactions() {
      this.showLoader = true;
      this.axios
        .get(
          `${configObject.apiBaseUrl}/Company/DealerDailyBranchTransaction/${
            this.$route.query.dealerId
              ? this.$route.query.dealerId
              : this.dealer.id
          }/${this.startDate}`,
          configObject.authConfig()
        )
        .then((response) => {
          this.showLoader = false;
          this.transCount = response.data.length;
          const reduceObj2 = response.data.reduce((acc, cur) => {
            if (acc[cur.branchName]) {
              acc[cur.branchName].push(cur);
            } else {
              acc[cur.branchName] = [];
            }
            return acc;
          }, {});

          const agoObj = response.data.filter((stations, index) => {
            return stations.productName === "AGO";
          });
          const dpkObj = response.data.filter((stations, index) => {
            return stations.productName === "DPK";
          });
          const pmsObj = response.data.filter((stations, index) => {
            return stations.productName === "PMS";
          });

          let reduceObj = [...pmsObj, ...dpkObj, ...agoObj];

          const newData = reduceObj.map((station, index) => {
            return {
              index: index + 1,
              branch: station.branchName,
              product: station.productName,
              transCount: station.dayTransaction,
            };
          });

          this.$refs.dataGrid.ej2Instances.setProperties({
            dataSource: newData,
          });
          this.refreshGrid();
        })
        .catch((error) => {
          console.log(error);
        });
    },
  },
};
</script>
